import React from 'react';
import { PropTypes } from 'prop-types';

import { Checkbox } from '@ontruck/orc';
import Tooltip from 'components/Tooltip';
import { GirdedQuestionIcon } from 'refactored/ui/icons';

const Extra = ({ name, className, label, handleChange, checked, tooltip }) => (
  <div className={className} data-testid="extra">
    <Checkbox
      name={name}
      label={label}
      size="L"
      onChange={handleChange}
      checked={checked}
    />
    <Tooltip
      className="tooltip"
      component={tooltip}
      segmentTitle="form extras"
      segmentData={{ label }}
    >
      <GirdedQuestionIcon />
    </Tooltip>
  </div>
);

Extra.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  checked: PropTypes.bool,
};

Extra.defaultProps = {
  checked: false,
};

export default Extra;
